var map = {
	"./2.png": 6870,
	"./BOOK.png": 3249,
	"./DINIKA PUBLICATIONS.png": 4089,
	"./DINIKALOGO.png": 7625,
	"./DINIKALOGOCROP.png": 2224,
	"./Untitled design.png": 2330,
	"./alphabet1.jpg": 6284,
	"./alphabet2.jpg": 2863,
	"./alphabet3.jpg": 9562,
	"./art2.jpg": 14,
	"./capital1.jpg": 5368,
	"./capital2.jpg": 5488,
	"./capital3.jpg": 3967,
	"./colours1.jpg": 3202,
	"./colours2.jpg": 296,
	"./colours3.jpg": 1761,
	"./colours4.jpg": 9318,
	"./colours5.jpg": 3417,
	"./colours6.jpg": 9098,
	"./colours7.jpg": 4936,
	"./colours8.jpg": 6862,
	"./computer1.jpg": 4341,
	"./computer2.jpg": 559,
	"./computer3.jpg": 482,
	"./computer4.jpg": 8146,
	"./computer5.jpg": 5418,
	"./computer6.jpg": 7011,
	"./computer7.jpg": 3079,
	"./cursive1.jpg": 2751,
	"./cursive2.jpg": 7922,
	"./cursive3.jpg": 2592,
	"./cursive4.jpg": 6453,
	"./cursive5.jpg": 7442,
	"./english1.jpg": 1867,
	"./english2.jpg": 7855,
	"./english3.jpg": 4433,
	"./english4.jpg": 2649,
	"./evs2.jpg": 4776,
	"./evs3.jpg": 5554,
	"./gk1.jpg": 3291,
	"./gk2.jpg": 7617,
	"./gk4.jpg": 4151,
	"./gk5.jpg": 9483,
	"./grammar1.jpg": 3830,
	"./grammar2.jpg": 699,
	"./grammar3.jpg": 4328,
	"./grammar5.jpg": 7702,
	"./gyan1.jpg": 5491,
	"./gyan2.jpg": 2088,
	"./gyan3.jpg": 9962,
	"./hindi1.jpg": 7450,
	"./hindi2.jpg": 950,
	"./hindi3.jpg": 8370,
	"./hindi4.jpg": 9487,
	"./image.png": 1169,
	"./lekhan1.jpg": 4779,
	"./lekhan2.jpg": 8885,
	"./lekhan3.jpg": 9004,
	"./number1.jpg": 8568,
	"./number2.jpg": 2642,
	"./number3.jpg": 8188,
	"./picture1.jpg": 9109,
	"./picture2.jpg": 6074,
	"./sulekh1.jpg": 8990,
	"./sulekh2.jpg": 2326,
	"./sulekh3.jpg": 4194,
	"./sulekh4.jpg": 889,
	"./sulekh5.jpg": 487,
	"./table1.jpg": 9412
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 990;